











import { listFactory } from '@/main/pages/listFactory';
import { cellNames, CellNamesObject, Row, intToRgb } from '@/main/utils/table';
import * as _ from 'lodash';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	async created() {
		this.DealerList = this.dropdownList.DealerList.map(s => s);
	},
	data() {
		return {
			partNo: null as string | null,
		};
	},
	computed: {
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.table);
		},
		partNoValue() {
			if (this.PartNumber) {
				this.partNo = this.PartNumber;
				return this.PartNumber;
			}

			if (this.table.rows[0]?.cells[1]) {
				this.PartNumber = this.table.rows[0]?.cells[1]!;
				this.partNo = this.PartNumber;
			} else if (this.partNo) {
				this.PartNumber = this.partNo;
			}
			return this.PartNumber;
		},
	},
	methods: {
		tableCellStyle({ row, column }:{ row: Row, column: any }) {
			if (_.has(this.cellNamesCmp, 'ROWCOLOR')) {
				const rgb = intToRgb(row.cells[this.cellNamesCmp.ROWCOLOR]);
				if (rgb) return { background: rgb };
			}
			return null;
		},
	},
});
